class CheckoutErrorNModal extends Modal {
    constructor() {
        super();
        this._stack = '';
        this._message = '';
        this._html = '';

        this.ok = this.querySelector('[data-ok]');
        this.abort = this.querySelector('[data-abort');
    }

    connectedCallback() {
        this.ok.addEventListener('click', this.handleOk.bind(this));
        this.abort.addEventListener('click', this.handleAbort.bind(this));
    }

    disconnectedCallback() {
        this.ok.removeEventlistener('click', this.handleOk.bind(this));
        this.abort.removeEventlistener('click', this.handleAbort.bind(this));
    }

    handleOk() {
        window.fetchQueue.pause = false;
        // window.fetchQueue.dequeue();
        this.close(this);
    }

    handleAbort() {
        document.dispatchEvent(new CustomEvent('queue-job:hide', { bubbles: true }));
        localStorage.setItem('queue', JSON.stringify([]));
        window.fetchQueue.queue = [];
        window.fetchQueue.pause = false;
        this.ok.disabled = true;
        this.abort.disabled = true;
        this.abort.classList.add('is-loading');
        window.location.reload();
    }

    get message() {
        return this._message;
    }

    set message(value) {
        this._message = value;
        this.querySelector('[data-message]').textContent = value;
    }

    get html() {
        return this._html;
    }

    set html(value) {
        this._html = value;
        this.querySelector('[data-html]').innerHTML = value;
    }

    get stack() {
        return this._details;
    }

    set stack(value) {
        this._stack = value;
        this.querySelector('[data-stack]').textContent = value;
    }

    open(evt) {
        //this.querySelector('.modal__window').style.maxWidth = 'unset';
        this.querySelector('[data-time]').textContent = new Date().toUTCString();
        this.querySelector(`[data-req-trace]`).innerHTML = this.prettyJson(JSON.parse(localStorage.getItem('req_trace') || '[]'));
        super.open(evt);
    }

    close(evt) {
        if (evt == undefined) return;
        super.close(evt);

        this.querySelector('[data-checkout-error-reset]').classList.remove('hidden-i');
        this.querySelector('[data-checkout-cart-restore]').classList.remove('hidden-i');
        this.ok.classList.add('hidden');
        this.abort.classList.add('hidden');
        //this.querySelector('[data-stack-container]').classList.remove('hidden');
    }

    prettyJson(input) {

        var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;

        var replacer = function (match, pIndent, pKey, pVal, pEnd) {
            var key = '<span class="json-key" style="color: brown">',
                val = '<span class="json-value" style="color: navy">',
                str = '<span class="json-string" style="color: olive">',
                r = pIndent || '';
            if (pKey)
                r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
            if (pVal)
                r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
            return r + (pEnd || '');
        };

        return JSON.stringify(input, null, 3)
            .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(jsonLine, replacer);
    }
}

customElements.define('checkout-error-modal', CheckoutErrorNModal);